import { TabularMeta_User } from '__generated__/TabularMeta_User';
import classNames from 'classnames';
import Icon from 'launch/components/Icon';
import Avatar from 'projects/components/Avatar';
import DesignerLevel from 'projects/components/DesignerLevel';
import OnlineStatus from 'projects/components/OnlineStatus';
import StatsTable from 'projects/components/StatsTable';
import { isDesignerOnline } from 'projects/util/designer';
import * as React from 'react';

export interface Props {
    designer: TabularMeta_User;
    onRemove?: (userId: number) => void;
    hasFullStats?: boolean;
}

const TabularMeta = ({ designer, hasFullStats = true, onRemove }: Props) => {
    const isOnlineNow = isDesignerOnline(designer);

    return (
        <div>
            <div
                className={classNames({
                    'designer-meta': true,
                    'designer-meta--minimal': !hasFullStats,
                })}
            >
                <div className="designer-meta__avatar">
                    <Avatar
                        userId={designer.id}
                        variations={['medium']}
                        isOnline={isOnlineNow}
                        onRemove={onRemove}
                    />
                </div>
                <div className="designer-meta__name">
                    <div className="paragraph paragraph--text paragraph--regular paragraph--no-margin">
                        {designer.displayName}
                    </div>
                </div>
                <div className="designer-meta__level">
                    <DesignerLevel level={designer.profile.designerLevel} />
                </div>
                <div className="designer-meta__icons">
                    {designer.profile.isContact && (
                        <Icon icon="contacts-1" offsetLeft={true} size={'large'} />
                    )}
                    {designer.profile.isFavorite && (
                        <Icon icon="heart-1" offsetLeft={true} highlight={true} />
                    )}
                </div>
                <div className="designer-meta__rating">
                    {designer.profile.review.rating}
                    <Icon icon="star-2" offsetLeft={true} />
                </div>
                {hasFullStats && (
                    <div className="designer-meta__online-status">
                        <OnlineStatus
                            isOnline={isOnlineNow}
                            lastSeenAt={designer.profile.lastSeenAt}
                        />
                    </div>
                )}
            </div>
            {hasFullStats && (
                <StatsTable>
                    <StatsTable.Stat
                        amount={designer.profile.completedProjectsCount}
                        label={
                            designer.profile.completedProjectsCount == 1
                                ? __('Project')
                                : __('Projects')
                        }
                    />
                    <StatsTable.Stat
                        amount={designer.profile.repeatCount}
                        label={
                            designer.profile.repeatCount == 1
                                ? __('Repeat client')
                                : __('Repeat clients')
                        }
                    />
                    <StatsTable.Stat
                        amount={`${designer.profile.responsivenessScore}%`}
                        label={__('Responds within 24 hours')}
                    />
                </StatsTable>
            )}
        </div>
    );
};

export default TabularMeta;
